import { z } from "zod";

export const CampaignPartnerSocialSchema = z.object({
  name: z.enum(["x", "discord", "telegram", "github"]),
  url: z.url(),
});

export type CampaignPartnerSocial = z.infer<typeof CampaignPartnerSocialSchema>;

export const CampaignPartnerSocialsSchema = z.array(CampaignPartnerSocialSchema);

export const SaveCampaignPartnerDtoSchema = z.object({
  id: z.string().optional(),
  name: z.string().min(1, "Name is required"),
  marketCap: z.number().optional().nullable(),
  allTimeLow: z.number().optional().nullable(),
  allTimeHigh: z.number().optional().nullable(),
  socials: CampaignPartnerSocialsSchema,
  websiteUrl: z.string().optional().nullable(),
  coinGeckoUrl: z.string().optional().nullable(),
  description: z.string(),
  logoUrl: z.string().optional().nullable(),
});

export type SaveCampaignPartnerDto = z.infer<typeof SaveCampaignPartnerDtoSchema>;

export const CampaignPartnerDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string(),
  socials: z.array(CampaignPartnerSocialSchema),
  marketCap: z.string().optional().nullable(),
  allTimeLow: z.string().optional().nullable(),
  allTimeHigh: z.string().optional().nullable(),
  websiteUrl: z.string().optional().nullable(),
  coinGeckoUrl: z.string().optional().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  logoUrl: z.string().optional().nullable(),
});

export type CampaignPartnerDto = z.infer<typeof CampaignPartnerDtoSchema>;

export const CampaignPartnerPreviewSchema = z.object({
  id: z.string(),
  name: z.string(),
  websiteUrl: z.string().optional().nullable(),
  coinGeckoUrl: z.string().optional().nullable(),
  marketCap: z.number().optional().nullable(),
  socialCount: z.number(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type CampaignPartnerPreview = z.infer<typeof CampaignPartnerPreviewSchema>;

export const ListCampaignPartnersRequestSchema = z.object({
  page: z.coerce.number(),
  size: z.coerce.number(),
  search: z.string().optional(),
});

export type ListCampaignPartnersRequest = z.infer<typeof ListCampaignPartnersRequestSchema>;

export const ListCampaignPartnersResponseSchema = z.object({
  partners: z.array(CampaignPartnerPreviewSchema),
  totalCount: z.number(),
  page: z.number(),
});

export type ListCampaignPartnersResponse = z.infer<typeof ListCampaignPartnersResponseSchema>;

export const SaveCampaignPartnersResponseSchema = z.object({
  message: z.string(),
  id: z.string(),
});

export type SaveCampaignPartnersResponse = z.infer<typeof SaveCampaignPartnersResponseSchema>;

export const GetCampaignPartnerByIdRequestSchema = z.object({
  id: z.string(),
});

export type GetCampaignPartnerByIdRequest = z.infer<typeof GetCampaignPartnerByIdRequestSchema>;
